import ReadOnlyField from "../../../../../Forms/ReadOnly/ReadOnlyField";

const RequestedInfoSection = ({ form }) => (
  <div className="grid grid-cols-2 gap-4 mt-6">
    <ReadOnlyField label="Solicitado Por" value={form.requestedByName} />
    <ReadOnlyField
      label="Fecha Solicitud"
      value={`${form.requestedDate} ${form.requestedTime}`}
    />
  </div>
);

export default RequestedInfoSection;
